// ----------------------------------------------------------------------

const account = {
  displayName: sessionStorage.nombre,
  email: sessionStorage.email,
  role: sessionStorage.nivel
};

export default account;
